// extracted by mini-css-extract-plugin
export var blockTitleLg = "schema-module--block-title-lg--68548";
export var col = "schema-module--col--1417a";
export var course_reviews = "schema-module--course_reviews--a39fc";
export var course_reviewsBlock = "schema-module--course_reviews-block--801ef";
export var course_reviewsBlock_video = "schema-module--course_reviews-block_video--faf6a";
export var schema = "schema-module--schema--a940d";